<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <card
            type="secondary"
            shadow
            header-classes="bg-white pb-5"
            body-classes="px-lg-5 py-lg-5"
            class="border-0"
          >
            <template>
              <div class="text-muted text-center mb-3">
                <small>
                  {{translate(getLanguage(), "Entre com")}}
                </small>
              </div>
              <template>
                <div id="customBtn" v-google-signin-button class="g-signin2 d-flex justify-content-center mb-3">
                  <div class="google-btn">
                    <div class="google-icon-wrapper">
                      <img class="google-icon" src="https://upload.wikimedia.org/wikipedia/commons/5/53/Google_%22G%22_Logo.svg"/>
                    </div>
                    <p class="btn-text"><b>Login</b></p>
                  </div>
                </div>
              </template>
            </template>

            <template>
              <div class="text-center text-muted mb-4">
                <small>
                  {{translate(getLanguage(), "Ou use seu email e uma senha para continuarmos")}}
                </small>
              </div>
              <form role="form">
                <base-input
                  v-model="name.value"
                  alternative
                  class="mb-3"
                  placeholder="Nome"
                  addon-left-icon="ni ni-hat-3"
                >
                </base-input>

                <ul class="form-errors">
                  <li v-for="(error, index) in name.errors" :key="index">
                    {{ error }}
                  </li>
                </ul>

                <base-input
                  v-model="email.value"
                  alternative
                  class="mb-3"
                  placeholder="Email"
                  addon-left-icon="ni ni-email-83"
                >
                </base-input>

                <ul class="form-errors">
                  <li v-for="(error, index) in email.errors" :key="index">
                    {{ error }}
                  </li>
                </ul>

                <base-input
                  v-model="password.value"
                  v-validate="'required'"
                  alternative
                  type="password"
                  placeholder="Senha"
                  addon-left-icon="ni ni-lock-circle-open"
                >
                </base-input>

                <base-input
                  v-model="password_confirmation.value"
                  name="password_confirmation"
                  v-validate="'required|confirmed:password'"
                  alternative
                  type="password"
                  placeholder="Confirmação"
                  data-vv-as="password"
                  addon-left-icon="ni ni-lock-circle-open"
                >
                </base-input>

                <ul class="form-errors">
                  <li v-for="(error, index) in password.errors" :key="index">
                    {{ error }}
                  </li>
                </ul>

<!--                 <div class="text-muted font-italic">
                  <small
                    >Força da senha:
                    <span class="text-success font-weight-700">forte</span>
                  </small>
                </div> -->

                <base-checkbox
                  v-model="TOS.value"
                >
                  <span>
                    {{translate(getLanguage(), "Eu concordo com os")}}
                    <router-link to="/tos" >
                    {{translate(getLanguage(), "Termos de serviço")}}
                    </router-link>
                    {{translate(getLanguage(), "e a")}}
                    <router-link to="/privacidade" >
                    {{translate(getLanguage(), "Politica de Privacidade")}}
                    </router-link>
                  </span>
                </base-checkbox>
                <ul class="form-errors">
                  <li v-for="(error, index) in TOS.errors" :key="index">
                    {{ error }}
                  </li>
                </ul>

                <div class="text-center">
                  <base-button type="primary" @click="submitForm" class="my-4">
                    {{translate(getLanguage(), "Faça o teste")}}!
                    </base-button>
                  <p class="text-danger">
                    {{translate(getLanguage(), "Ao se registrar o teste já vai começar!!")}}
                  </p>
                </div>
              </form>
            </template>
          </card>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
// import Cookies from "../utils/Cookies";
import translate from "../i18n/i18n.js";
import router from "../router.js";

let gapi = document.createElement('script')
gapi.setAttribute('src', 'https://apis.google.com/js/platform.js')


export default {
  // directives: {
  //   GoogleSignInButton
  // },
  mounted: () => {
    // eslint-disable-next-line
    //gapi.signin2.render('google-signin-button', {
    //  onsuccess: this.onSignIn
    //})
  },
  data: () => ({
    email: {
      value: null,
      errors: [],
    },
    name: {
      value: null,
      errors: [],
    },
    password: {
      value: null,
      errors: [],
    },
    password_confirmation: {
      value: null,
      errors: [],
    },
    TOS: {
      value: false,
      error: [],
    },
  }),
  methods: {
    getLanguage(){
      return localStorage.getItem('language') || 0;
    },
    translate: function(language, phrase){
      return translate(language, phrase);
    },
    OnGoogleAuthSuccess (googleUser, idToken) {
      // Receive the idToken and make your magic with the backend
      const url = process.env.VUE_APP_API_URL + "/googletoken";
      const body = {
        id_token: idToken,
        name: googleUser.getBasicProfile().getName(),
      };
      console.log(body);

      console.log('/googletoken');
      fetch(url, {
        method: "POST", // *GET, POST, PUT, DELETE, etc.
        mode: "cors", // no-cors, cors, *same-origin
        cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
        credentials: "same-origin", // include, *same-origin, omit
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(body) // body data type must match "Content-Type" header
      })
        .then(res => res.json())
        .then(data => {
          const { status, message, token, ...userData } = data;
          if(!status) {
            this.handleRegisterError(message, status);
            return;
          }

          if (token) {
            console.log('isauth1=', this.$store.getters.isAuthenticated);
            console.log('user1=', this.$store.getters.user);
            this.$store.dispatch('setToken', token);
            this.$store.dispatch('setUser', userData);
            console.log('isauth2=', this.$store.getters.isAuthenticated);
            console.log('user2=', this.$store.getters.user);

            router.push("/quiz");
          }
        })
        .catch(error => {
          this.handleRegisterError(error, {})
        });
    },
    OnGoogleAuthFail (error) {
      console.log(error)
    },
    validEmail: function(email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    isValidForm() {
      this.name.errors = [];
      this.email.errors = [];
      this.password.errors = [];
      this.TOS.errors = [];

      if (!this.email.value) {
        this.email.errors.push("Email required.");
      } else if (!this.validEmail(this.email.value)) {
        this.email.errors.push("Invalid email.");
      }

      if (!this.name.value) {
        this.name.errors.push("Username required.");
      }

      if (!this.password.value) {
        this.password.errors.push("Password required.");
      }

      if (!this.password_confirmation.value) {
        this.password.errors.push("Password Confirmation required.");
      }

      if (this.password_confirmation.value != this.password.value) {
        this.password.errors.push("Password and Password Confirmation don't match.");
      }

      if(!this.TOS.value) {
        this.TOS.errors.push("Terms of Service must be agreed to.");
      }

      if (
        this.password.errors.length > 0 ||
        this.email.errors.length > 0 ||
        this.name.errors.length > 0 ||
        this.TOS.errors.length > 0
      ) {
        console.log(" *** Input errors");
        return false;
      }

      //console.log(' *** name  = ' + this.name.value );
      //console.log(' *** email = ' + this.email.value );
      //console.log(' *** pass  = ' + this.password.value );
      //return false;

      return true;
    },
    async submitForm() {
      if (!this.isValidForm()) {
        return;
      }

      const user = {
        name: this.name.value,
        surname: " ",
        email: this.email.value,
        password: this.password.value
      };

      const url = process.env.VUE_APP_API_URL + "/register";

      console.log('/register');
      fetch(url, {
        method: "POST", // *GET, POST, PUT, DELETE, etc.
        mode: "cors", // no-cors, cors, *same-origin
        cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
        credentials: "same-origin", // include, *same-origin, omit
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(user) // body data type must match "Content-Type" header
      })
        .then(res => res.json())
        .then(data => {
          const { status, error, token, ...userData } = data;
          if(!status) {
            this.handleRegisterError(error, status);
            return;
          }

          if (token) {
            console.log('isauth1=', this.$store.getters.isAuthenticated);
            console.log('user1=', this.$store.getters.user);
            this.$store.dispatch('setToken', token);
            this.$store.dispatch('setUser', userData);
            console.log('isauth2=', this.$store.getters.isAuthenticated);
            console.log('user2=', this.$store.getters.user);

            router.push("/quiz");
          }
        })
        .catch(error => {
          this.handleRegisterError(error, {})
        });
    },

    handleRegisterError(error, more) {
      console.error("register error");
      console.error(error);
      console.error(more);
      if(error.Constraint === "uix_users_email") {
        this.email.errors.push("User already exists.");
      }
    },
  }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@100;300;400;500&display=swap');

.google-btn {
  width: 120px;
  height: 36px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 3px 4px 0 rgba(0, 0, 0, 0.25);
}
.google-btn .google-icon-wrapper {
  position: absolute;
  /* margin-top: 1px;
  margin-left: 1px; */
  width: 40px;
  height: 40px;
  border-radius: 2px;
  /* background-color: #fff; */
}
.google-btn .google-icon {
  position: absolute;
  margin-top: 8px;
  margin-left: 8px;
  width: 18px;
  height: 18px;
}
.google-btn .btn-text {
  float: right;
  margin: 6px 26px 0 0;
  font-family: Roboto, arial, sans-serif;
  font-weight: 300;
  font-size: 13px;
  letter-spacing: 0.21px;
}
.google-btn:hover {
  box-shadow: 0 0 6px #4285f4;
  cursor: pointer;
}
</style>

